import { IBankAccount, IBankBalance } from '@common/interfaces/bankAccount'
import { combineReducers } from 'redux'
import { createLoadingDataReducer } from '../../helpers/redux'
import { IAction } from '../apiMiddleware'
import * as actions from './actions'

export default combineReducers({
  loadingArray(state: string[] = [], action: IAction): string[] {
    switch (action.type) {
      case actions.CREATE_REQUEST:
      case actions.LIST_REQUEST:
      case actions.DELETE_REQUEST:
      case actions.UPDATE_REQUEST:
      case actions.LIST_BALANCES_REQUEST:
      case actions.UNLINK_PLAID_REQUEST:
      case actions.SET_CLOSED_REQUEST:
        return [...state, action.type]
      case actions.CREATE_SUCCESS:
      case actions.CREATE_FAILURE:
      case actions.LIST_SUCCESS:
      case actions.LIST_FAILURE:
      case actions.DELETE_SUCCESS:
      case actions.DELETE_FAILURE:
      case actions.UPDATE_SUCCESS:
      case actions.UPDATE_FAILURE:
      case actions.LIST_BALANCES_SUCCESS:
      case actions.LIST_BALANCES_FAILURE:
      case actions.UNLINK_PLAID_SUCCESS:
      case actions.UNLINK_PLAID_FAILURE:
      case actions.SET_CLOSED_SUCCESS:
      case actions.SET_CLOSED_FAILURE:
        return state.filter(
          (item) =>
            item !== action.type.replace('SUCCESS', 'REQUEST').replace('FAILURE', 'REQUEST'),
        )
      default:
        return state
    }
  },
  list: createLoadingDataReducer<{ data: IBankAccount[]; hasAccountNeedingReconnect?: boolean }>(
    [actions.LIST_REQUEST],
    [actions.CREATE_REQUEST, actions.UPDATE_REQUEST, actions.DELETE_REQUEST],
    true,
    undefined, // resetActionTypes
    true, // withMergeOnUpdate - fields an update response leaves out stay on the row
  ),
  balances(state: IBankBalance[] = [], action: IAction): IBankBalance[] {
    switch (action.type) {
      case actions.LIST_BALANCES_SUCCESS:
        return action.data as IBankBalance[]
      default:
        return state
    }
  },
})
